import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import KremlinStoryPage from './storypages/KremlinStoryPage/KremlinStoryPage';


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/p" element={<KremlinStoryPage />} />
            </Routes>
        </Router>
    );
}

export default App;
